import { AccountInfo, PublicClientApplication } from '@azure/msal-browser';
import { AxiosResponse } from "axios";
// Removed unused import of useTranslation

export function getUserEmailAndOID(accounts: AccountInfo[]) {
  const oid: string = accounts[0].idTokenClaims?.email as string;
  const userEmail = accounts[0].idTokenClaims?.email;

  return { userEmail, oid }
}

export async function getToken(
  userEmail: string,
  msalInstance: PublicClientApplication,
  getAccessToken: (email: string) => Promise<AxiosResponse<any, any>>,
  alertMessage: string
) {
  try {
    const tokenResponse = await getAccessToken(userEmail as string);
    const token: string = tokenResponse.data;
    if (!token) {
      alert(alertMessage);
      await msalInstance.logoutRedirect();
    }

    return token;
  } catch (error) {
    alert(alertMessage);
    await msalInstance.logoutRedirect();
  }
}

export function scrollToAnchor(anchor: HTMLElement | null) {
  if (anchor) {
    anchor.scrollIntoView({ behavior: "smooth" });
  }
}
